import { dateToTimestamp, getToday, addMonths } from '@ha/date';

import { FilterBuilder } from '../Types';

const dateFromFilter = (startDate: string) => {
  const startDateTS = dateToTimestamp(new Date(startDate));

  return `dateFromTS<=${startDateTS}`;
};

const dateToFilter = (startDate: string, endDate?: string) => {
  // if end date is specified then use that, otherwise use the startDate
  const endDateTS = dateToTimestamp(new Date(endDate || startDate));

  return `dateToTS>=${endDateTS}`;
};

const endOfBookableWindowFilter = (startDate: string) => {
  // This is to address the issue with listings that have maxBookable window:
  // https://housinganywhere.atlassian.net/browse/TX-251
  // When the listing has no maxBookableWindow the endOfBookableWindowTs is set to NO_END.

  const startDateTS = dateToTimestamp(new Date(startDate));
  return `endOfBookableWindowTS>=${startDateTS}`;
};

const dateTSBuilder: FilterBuilder = ({ startDate, endDate }, context) => {
  const withMoveInWindowFilter = context?.withMoveInWindowFilter;

  // when no dates are specified then return all the inventory that has
  // availability in the next 6 months.
  if (!startDate) {
    const today = getToday();
    const todayPlusSixMonths = addMonths(today, 6);

    return dateFromFilter(todayPlusSixMonths);
  }

  const dateFrom = dateFromFilter(startDate);
  const dateTo = dateToFilter(startDate, endDate);
  const endOfBookableWindowFilterTs = endOfBookableWindowFilter(startDate);

  if (withMoveInWindowFilter) {
    return [dateFrom, endOfBookableWindowFilterTs, dateTo].join(' AND ');
  } else {
    return [dateFrom, dateTo].join(' AND ');
  }
};

export { dateTSBuilder };
